import { Trans } from '~/common/context';
import { Button, Text } from '@wyz/ui';
import { IProximityStock } from '@wyz/types';

type Props = {
  proximityStocks?: IProximityStock[];
  onShowAll?: () => void;
  showAll?: boolean;
};
function ProximityStocksTable({ proximityStocks, onShowAll, showAll }: Props) {
  const stocks = proximityStocks || [];
  const displayedStocks = showAll ? stocks : stocks.slice(0, 3);
  if (stocks.length > 0) {
    return (
      <>
        <Text
          color='secondary-gray'
          heading='sm'
          weight='bold'
          className='mt-4'
        >
          <Trans i18nKey='app.common.supplier.proximity_stocks' />
        </Text>
        <table className='w-100 mt-2 mb-2'>
          <thead>
            <tr>
              <th>
                <Text heading='xs' weight='semi-bold' color='secondary-gray'>
                  <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.source' />
                </Text>
              </th>
              <th>
                <Text heading='xs' weight='semi-bold' color='secondary-gray'>
                  <Trans i18nKey='app.purchase.quote_search_page.product.stock.table.delay' />
                </Text>
              </th>
              <th>
                <Text heading='xs' weight='semi-bold' color='secondary-gray'>
                  <Trans i18nKey='app.common.quantity' />
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {displayedStocks.map((stock, index) => (
              <tr key={index}>
                <td>
                  <Text heading='xs' weight='semi-bold' color='secondary'>
                    {stock.supplierName} {stock.supplierCity}
                  </Text>
                </td>
                <td>
                  <Text heading='xs' weight='semi-bold' color='secondary'>
                    {'/'}
                  </Text>
                </td>
                <td>
                  <Text heading='xs' weight='semi-bold' color='secondary'>
                    {stock.quantity}
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!showAll && stocks.length > 3 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button id='show-all-stocks' variant='link' onClick={onShowAll}>
              <Trans i18nKey='app.purchase.quote_search_page.product.stock.show_all' />
            </Button>
          </div>
        )}
      </>
    );
  }
  return <></>;
}
export default ProximityStocksTable;
